import { UniIconButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { TextBody, TextTitle } from '@/design-system/components/typography';
import { LayoutContext } from 'contexts/LayoutContext';
import { SxProp, View, useDripsyTheme, styled } from 'dripsy';
import _ from 'lodash';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { SetCardLimitStackParamList, SetCardLimitStackRoutes } from './type';
import { PageHeaderModalNative } from '../page/PageHeaderModalNative';
import { CardWithLimitProp } from '../../types';

export interface SetCardLimitProps {
  onClose: () => void;
  onLayout: (event: any) => void;
  onDailyLimitType?: (type: string) => void;
  account: string;
  tab?: number;
  record?: CardWithLimitProp;
  func?: (cardId: string, atmLimit?: number, purchaseLimit?: number) => void;
  refresh?: () => void;
}

export const SetCardLimitNativeZeroScreen: React.FC<SetCardLimitProps> = (props) => {
  const { onClose, onLayout, onDailyLimitType, account, tab, record, func, refresh } = props;
  const { t } = useTranslation('account-management');
  const { modal, textMb, itemStyle } = sxStyles;
  const layout = useContext(LayoutContext);

  const navigation = useNavigation<NativeStackNavigationProp<SetCardLimitStackParamList>>();
  const dailyLimitType = (type: string) => {
    onDailyLimitType && onDailyLimitType(type);
    navigation.navigate(SetCardLimitStackRoutes.DailyPurchaseLimit, {
      onLayout: onLayout,
      dailyLimitType: type,
      account,
      tab,
      record,
      func,
      refresh
    });
  };

  const { theme } = useDripsyTheme();

  return (
    <View>
      <PageHeaderModalNative>
        <View sx={{ px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ position: 'absolute', top: 0, left: 12, zIndex: 2 }}>
            <UniIconButton
              icon="arrowLeft"
              options={{ iconStyles: { color: theme?.colors?.$white as string } }}
              onPress={onClose}></UniIconButton>
          </View>
          <View sx={{ textAlign: 'center', width: '100%' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::set-card-limit.title--set-card-limit')}
            </TextTitle>
          </View>
        </View>
      </PageHeaderModalNative>
      <View sx={modal}>
        <TextTitle sx={textMb} semiBold>
          {t('card-account-management::set-card-limit.text--select-limit-type')}
        </TextTitle>
        <View sx={{ gap: 10 }}>
          <TextBody sx={itemStyle} onPress={() => dailyLimitType('PurchaseLimit')}>
            <TextBody semiBold>{t('card-account-management::set-card-limit.title--daily-purchase-limit')}</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
          <TextBody sx={itemStyle} onPress={() => dailyLimitType('ATMWithdrawalLimit')}>
            <TextBody semiBold>{t('card-account-management::set-card-limit.title--daily-withdraw-limit')}</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
          <TextBody sx={itemStyle} onPress={() => dailyLimitType('DailyLimit')}>
            <TextBody semiBold>{t('card-account-management::set-card-limit.title--daily-limit')}</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
          <TextBody sx={itemStyle} onPress={() => dailyLimitType('SingleTransactionLimit')}>
            <TextBody semiBold>{t('card-account-management::set-card-limit.title--single-transaction-limit')}</TextBody>
            <Icon name="arrowRightOrangeCircle" />
          </TextBody>
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    px: '$4',
    py: '$5'
  },
  topHeader: {
    justifyContent: 'center'
  },
  textMb: {
    marginBottom: 20
  },
  itemStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 20,
    py: 30,
    cursor: 'pointer',
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowRadius: 10,
    borderRadius: 10
  }
};
